import { getBaseUrl } from "@/lib/getBaseURL";

interface NewsItem {
    documentId: string;
    newsThumbnail: {
      url: string;
    };
    category: string;
    headline: string;
    publishedAt: string;
  }
  
  interface NewsList {
    data: NewsItem[];
  }
  
  const fetchNews = async (): Promise<NewsItem[]> => {
    try {
      const res = await fetch(
        `${getBaseUrl()}/api/news-contents?populate[newsThumbnail][fields][0]=url&fields[0]=id&fields[1]=category&fields[2]=headline&fields[3]=publishedAt&locale=en&sort=publishedAt:desc`
      );
  
      if (!res.ok) {
        throw new Error('Failed to fetch news data');
      }
  
      const newsData: NewsList = await res.json();
  
      // console.log('Fetched News Data:', newsData.data);
      return newsData.data;
    } catch (error) {
      console.error('Error fetching news:', error);
      return [];
    }
  };
  
  export default fetchNews;
  